"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ES_PHONE_HELPER_CONFIG = void 0;
exports.ES_PHONE_HELPER_CONFIG = {
    validationRegex: /^[6789*][\d*]{8}$/,
    countryCode: '34',
    phoneMask: '### ## ## ##',
    obfuscateMask: '##* ** ** ##',
};
//# sourceMappingURL=ESConfig.js.map